// OvarianReserveCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { OVARIAN } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function OvarianReserveCard() {
  const { t } = useTranslation();

  const panel = {
    id: "ovarian_reserve",
    title: t("card_ovarian_title"),
    subtitle: t("card_ovarian_desc"),
    biomarkers: t("card_ovarian_markers"),
    price: "€ 49",
    image: OVARIAN,
  };

  return <BasePackageCard panel={panel} />;
}